import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FNSimple } from '../../models/FNSimple';

@Component({
	selector: 'app-step2common',
	templateUrl: './step2common.component.html'
})
export class Step2CommonComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'FNSimple';
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() fnSimple: FNSimple;
	@Input() linkForRouter: string;

	constructor() {}

	ngOnInit(): void {}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
